import React from "react";
import { FaCheck } from "react-icons/fa";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import tinycolor from "tinycolor2";
import COLORS from "scss/colors.module.scss";
import styled, { css } from "styled-components";

export default function ColorList({
  colors = COLORS.HEADER_BACKGROUNDS.split(","),
  onChange,
  value,
  size = "normal",
  type = "square",
}) {
  return (
    <StyledDiv>
      {colors.map((color, index) => (
        <ColorRectange
          key={index}
          color={color}
          onChange={onChange}
          isSelected={value === color}
          size={size}
          type={type}
        />
      ))}
    </StyledDiv>
  );
}

export function ColorRectange({
  color,
  onChange,
  isSelected,
  onClick,
  size = "normal",
  type = "square",
  isShowArrowDropDownIcon = false,
  isDefaultCursor = false,
}) {
  return (
    <StyledColorDiv
      isShowArrowDropDownIcon={isShowArrowDropDownIcon}
      isDefaultCursor={isDefaultCursor}
      color={color}
      size={size}
      type={type}
      onClick={(e) => {
        onChange?.(color);
        onClick?.(e);
      }}
    >
      {isShowArrowDropDownIcon && (
        <StyledArrowDropDownIcon isLightColor={tinycolor(color).isLight()} />
      )}
      {isSelected && (
        <FaCheck
          size={12}
          color={COLORS.PRIMARY_COLOR}
          style={{ alignSelf: "center" }}
        />
      )}
    </StyledColorDiv>
  );
}

const StyledArrowDropDownIcon = styled(ArrowDropDownIcon)`
  align-self: center;
  ${(props) =>
    props.isLightColor
      ? css`
          color: #000 !important;
        `
      : css`
          color: #fff !important;
        `};
`;

const StyledDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 200px;
  max-height: 200px;
  margin: 5px;
`;

const StyledColorDiv = styled.div`
  opacity: 0.8;
  margin: 1px;
  margin-bottom: 3px;
  box-shadow: inset 0 0 0 2px hsla(0, 0%, 0%, 0.05);
  display: flex;
  justify-content: center;
  ${(props) =>
    props.isShowArrowDropDownIcon
      ? css`
          width: 24px;
          height: 24px;
          border-radius: 6px;
          background-color: ${props.color};
          cursor: ${props.isDefaultCursor === true
            ? "default"
            : "pointer"};
        `
      : css`
          width: ${props.size === "normal" ? "23px" : "32px"};
          height: ${props.size === "normal" ? "23px" : "32px"};
          border-radius: ${props.type === "square" ? "3px" : "16px"};
          background-color: ${props.color};
          cursor: ${props.isDefaultCursor === true
            ? "default"
            : "pointer"};
        `};
`;